export const MESSAGE_ROLES = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
};
export const AVATAR_LABELS = {
  ASSISTANT_SHORT: 'AI',
  USER_FULL: 'You',
};

export const CHAT_WINDOW_SIZES = {
  WIDTH: 600,
  HEIGHT: 800,
  SIDEBAR_WIDTH: 200,
  MOBILE_WIDTH: 280,
  MOBILE_SIDEBAR_WIDTH: 180,
};

export const SESSION_STATES = {
  NEW_CHAT_TITLE: 'New Chat',
};

export const UI_STATES = {
  LOADING: 'loading',
  IDLE: 'idle',
  ERROR: 'error',
  PENDING: 'pending',
  DELIVERED: 'delivered',
};

export const KEYBOARD_EVENTS = {
  ENTER: 'Enter',
};

export const CHAT_SESSION_PAGINATION = {
  DEFAULT_PER_PAGE: 10,
  DEFAULT_PAGE: 1,
};
